import React, { useEffect } from 'react';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { useAuth } from '@leagueplatform/auth-utils';
import { identify } from '@leagueplatform/analytics';
import { useNavigate } from 'react-router-dom';
import { usePersonalInformation } from '@scfhp-web/shared-module';
import { useUserEligibility } from 'hooks/use-user-eligibility.hook';
import { ErrorTypes } from 'hooks/use-error-message.hook';
import { NotEligibleScreen } from 'components/error/not-eligible-screen.component';
// import { buildErrorUrlParams } from 'utils/auth-error-helpers';
// import { AUTH0_ERROR_TYPES } from 'common/constants';
// import { StandaloneAuth } from '@leagueplatform/auth-standalone';

export const AuthSessionContainer = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const { isAuthenticated, error } = useAuth({
    redirectToLogInWhenSignedOut: true,
  });
  const { data } = usePersonalInformation();

  const { eligible, loading } = useUserEligibility(isAuthenticated);

  const navigate = useNavigate();
  // const location = useLocation();

  useEffect(() => {
    // Only navigate to sign-out on auth errors
    // The redirectToLogInWhenSignedOut option handles unauthenticated users
    if (error) {
      navigate(`/sign-out`);
    }
  }, [error, navigate]);

  useEffect(() => {
    if (isAuthenticated && data.userId) {
      identify({
        id: data.userId as string,
        employer_group_id: '',
        tenant_id: 'scfhp',
      });
    }
  }, [isAuthenticated, data]);

  const isLoading = !isAuthenticated || loading;
  const isIneligible = eligible === false;

  // Always render children to keep React Router route matching working
  // This prevents "No routes matched" warnings in React Router v6
  return (
    <>
      {isLoading && <LoadingIndicator />}
      {isIneligible && !isLoading && (
        <NotEligibleScreen errorType={ErrorTypes.NOT_ELIGIBLE} />
      )}
      {/* Always render children but hide when loading or ineligible */}
      <div style={{ display: isLoading || isIneligible ? 'none' : 'contents' }}>
        {children}
      </div>
    </>
  );
};
